module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p innerHTML=\"{{message}}\"> <i class=\"fa fa-spinner fa-spin fa-fw\"></i></p>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event/event.component.html
// module id = ./src/app/components/event/event.component.html
// module chunks = main